<template>
	<div class="user-management-container">
		<el-button type="text" @click="dialogVisible = true">点击打开 Dialog</el-button>
		 
		<!-- <el-dialog title="" width="80%" v-model="dialogVisible">
			<div class="zxc" style="min-height: 260px;">
				<pop-form v-model="TabelSN" @menuClick="menuClick2(v); snSaveForm(v)" @snSaveForm="snSaveForm"></pop-form>
		  	</div>
		</el-dialog> -->
	</div>
</template>

<script>
	import axios from "axios"
	import popForm from "@/formComponents/popForm.vue"
	import {
		errMsg,
		successMsg
	} from "@/notify/index.js"

	export default {
		name: "CusRepairList",
		components: {
			popForm
		},
		data() {
			return {
				dialogVisible: false,
				TabelSN: false,
				// SN号添加
				snAdd: {
					ModelNoId: null, 		// ModelNoId	int	型号Id	是
					ContractId: null,		// ContractId	int	合同Id	是
					compid: null,			// compid	int	公司Id	
					NotExpress: false,		// NotExpress	Bool	是否递送	
					Name: '',					// Name	string	SN号	是
					ContractName: '',			// ContractName	string	合同号	是
					SystemName: 'zxc',				// SystemName	string	系统	
					Fusion: '',					// Fusion	string	Fusion版本	
					MACAddr: '',				// MACAddr	string	MAC地址	
					IPAddr: '',					// IPAddr	string	IP地址	
					DNSAddr: '',				// DNSAddr	string	网关掩码DNS	
					Licensee: '',				// Licensee	string	LicenseeName	
					RegeditInfo: '',			// RegeditInfo	string	Wavelink注册信息	
					State: false,		// State	Bool	是否巡检	
				},
				ruleForm: {
					cycle: null, 				// cycle	Decimal	周期	-
					CompanyId: null, 		// CompanyId	int	客户Id	是-
					DicInfoId: null, 		// DicInfoId	int	合同类型id	是
					ContractNo: '', 		// ContractNo	String	合同号	是
					BuyDate: '', 			// BuyDate	String	购买日期	是
					EndDate: '', 			// EndDate	String	截止日期	是
					rimDate: '', 			// rimDate	String	提醒日期	
					Month: null, 			// Month	Int	月限	是
					Appendix: '', 			// Appendix	String	备注	
					sn: '', 	 			// sn	String	SN号	是
					mid: null, 				// mid	Int	型号Id	是
					companyArray: [], 		// companyArray	String	服务公司	
					notExpress: false	 	// notExpress	Bool	是否递送	
				},
				rules: {
				  cycle: [
					{ required: true, message: '请输入', trigger: 'blur' },
					// { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
				  ] ,
				  CompanyId: [
					{ required: true, message: '请输入', trigger: 'blur' },
				  ] ,
				  DicInfoId: [
					{ required: true, message: '请输入', trigger: 'blur' },
				  ] ,
				  ContractNo: [
					{ required: true, message: '请输入', trigger: 'blur' },
				  ] ,
				  BuyDate: [
					{ required: true, message: '请输入', trigger: 'blur' },
				  ] ,
				  EndDate: [
					{ required: true, message: '请输入', trigger: 'blur' },
				  ] ,
				  Month: [
					{ required: true, message: '请输入', trigger: 'blur' },
				  ] ,
				  sn: [
					{ required: true, message: '请输入', trigger: 'blur' },
				  ] ,
				  mid: [
					{ required: true, message: '请输入', trigger: 'blur' },
				  ]
				}
			}
		},
		created() {
		    
		},
		computed:{
			
		},
		methods: {
			/* handleClose(done) {
				this.$confirm('确认关闭？')
				  .then(_ => {
					done();
				  })
				  .catch(_ => {});
			  },
			menuClick2(param){
				console.log('3',param)
			},
			snSaveForm(param){
				console.log('4',param)
				this.dialogVisible = false
			} */
		}
	}
</script>

<style lang="scss" scoped="scoped">
	/* @import "~@/assets/styles/_handle.scss";
	.user-management-container {
		 
		.pub_dialog {
		    display: flex;
		    justify-content: center;
		    align-items: Center;
		    overflow: hidden;
		    .el-dialog {
		        margin: 0 auto !important;
		        height: 300px;
		        overflow: hidden;
		        .el-dialog__body {
		            position: absolute;
		            left: 0;
		            top: 54px;
		            bottom: 0;
		            right: 0;
		            padding: 0;
		            z-index: 1;
		            overflow: hidden;
		            overflow-y: auto;
					max-height: 60%;
		        }
				
		    }
		}
		
		
	} */
	 
</style>
